import { BlogArticle, BlogArticleAdapter } from '@shared/models/blog-article.model';
import { BlogService, TrackingService } from '@core/services';
import { Component, OnInit } from '@angular/core';
import { debounceTime, distinctUntilChanged, take } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { GhGlobal } from '@shared/helpers/global-functions';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Router } from '@angular/router';
import { environment } from '@env/environment';

@Component({
    selector: 'gh-search',
    templateUrl: './search.component.html',
    standalone: false
})
export class SearchComponent implements OnInit {
  searchControl = new UntypedFormControl();
  articleTitles = [];

  private searchTerms = [];

  constructor(
    private router: Router,
    private blogService: BlogService,
    private blogArticleAdapter: BlogArticleAdapter,
    private trackingService: TrackingService
  ) { }

  ngOnInit() {
    this.searchControl.valueChanges
      .pipe(
        debounceTime(500),       // wait for 300ms pause in events
        distinctUntilChanged()
      )  // ignore if next search term is same as previous
      .subscribe((term: string) => {
        this.articleTitles = [];
        if (term) {
          term = this.normalizeInput(term);
          if (term.length > 2) {
            this.searchTerms = term.split(/\s/g);
            this.getArticlesByTitle(term);
          }
        }
      });
  }

  navigateToArticle(event: MatAutocompleteSelectedEvent) {
    const selectedArticle = event.option.value;
    this.searchControl.setValue('');
    const selectedArticlePath = `./${selectedArticle.category.slug}/${selectedArticle.slug}`;
    this.sendAnalyticsEvent(this.searchTerms.join(' '));
    this.navigateTo([selectedArticlePath]);
  }

  searchOnEnter(event: any) { // KeyboardEvent
    const terms: string = this.normalizeInput(this.searchControl.value);
    if (event.key === 'Enter') {
      this.navigateTo(['/search-results', 'terms', terms]);
      this.searchControl.setValue('');
      this.sendAnalyticsEvent(terms);
    }
  }

  private getArticlesByTitle(term: string) {
    this.blogService.findArticlesByTitle(term)
      .pipe(
        take(1),
      )
      .subscribe((res) => {
        this.articleTitles = [];
        if (res && !res.error) {
          const articles: BlogArticle[] = res || [];
          articles.forEach((article) => {
            article.title = GhGlobal.wrapWithBold(article.title, this.searchTerms);
            this.articleTitles.push(this.blogArticleAdapter.adapt(article));
          });
        }
      });
  }

  private navigateTo(path: any[], extras = {}) {
    this.router.navigate(path, extras);
  }

  private normalizeInput(terms: string): string {
    return terms ? terms.toLowerCase().trim().replace(/\s\s+/g, ' ') : '';
  }

  private sendAnalyticsEvent(terms: string): void {
    this.trackingService.setDataLayerAttributes({
      event: 'interactionEvent',
      event_name: 'submit_search',
      events: {
        feature: 'blog',
        environment: environment.env,
        click_text: terms
      }
    });
  }

}
